import React from 'react';
import {Stack} from '@mui/material';
import {Body} from '@lightricks/react-design-system';
import useVersionMessagesQuery from '@/hooks/queries/messages/use-version-messages-query';
import useSendMessage from '@/hooks/queries/mutations/use-send-message';
import {SendMessagePayload} from '@/api/messages/types';
import {captureDeliverablesError} from '../telemetry';
import MessageThread from './MessageThread';
import styles from './VersionChat.module.scss';

interface Props {
  versionId: string;
}

export default function VersionChat({versionId}: Props) {
  const {messages, isLoading, isError} = useVersionMessagesQuery(versionId);
  const sendMessage = useSendMessage(
    {kind: 'version', id: versionId},
    {
      onError: (e) =>
        captureDeliverablesError(e, 'Failed to send version message', {
          versionId,
        }),
    }
  );

  const handleSend = (payload: SendMessagePayload) =>
    sendMessage.mutateAsync(payload);

  return (
    <Stack
      direction="column"
      className={styles.versionChat}
      data-testid="version-chat"
    >
      <MessageThread
        messages={messages}
        isLoading={isLoading}
        isError={isError}
        onSend={handleSend}
        allowAttachments
        emptyState={
          <>
            <Body size="md">
              <strong>No messages about this upload yet.</strong>
            </Body>
            <Body size="sm">
              This thread is separate from requests to edit your upload.
            </Body>
          </>
        }
      />
    </Stack>
  );
}
